// Vue 3 entry
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
